var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable no-unused-vars */
import { Checkbox } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { multipleStringAccessorExtractor } from '../../../../commons/utils/JSONUtils';
import { CheckBoxWrapper, CompactFormControlLabel, CustomHelperText, Wrapper, } from './CustomFormikWeekCheckbox.Styles';
export var CustomFormikWeekCheckbox = function (_a) {
    var form = _a.form, field = _a.field, label = _a.label;
    var _b = useState({
        sunday: false,
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false
    }), state = _b[0], setState = _b[1];
    var errorValue = multipleStringAccessorExtractor(field.name, form.errors);
    var willError = !!errorValue;
    useEffect(function () {
        var days = field.value;
        if (days && days.length > 0) {
            setState({
                sunday: !!(days === null || days === void 0 ? void 0 : days.find(function (day) { return day === 'sunday'; })),
                monday: !!(days === null || days === void 0 ? void 0 : days.find(function (day) { return day === 'monday'; })),
                tuesday: !!(days === null || days === void 0 ? void 0 : days.find(function (day) { return day === 'tuesday'; })),
                wednesday: !!(days === null || days === void 0 ? void 0 : days.find(function (day) { return day === 'wednesday'; })),
                thursday: !!(days === null || days === void 0 ? void 0 : days.find(function (day) { return day === 'thursday'; })),
                friday: !!(days === null || days === void 0 ? void 0 : days.find(function (day) { return day === 'friday'; })),
                saturday: !!(days === null || days === void 0 ? void 0 : days.find(function (day) { return day === 'saturday'; }))
            });
        }
    }, [field.value]);
    var handleChange = function (event) {
        var _a;
        var _state = __assign(__assign({}, state), (_a = {}, _a[event.target.name] = event.target.checked, _a));
        setState(_state);
        var selectedDays = Object.entries(_state)
            .filter(function (e) { return e[1]; })
            .map(function (e) { return e[0]; });
        form.setFieldValue(field.name, selectedDays);
    };
    return (React.createElement(Wrapper, null,
        React.createElement(CustomHelperText, null, label),
        React.createElement(CheckBoxWrapper, null,
            React.createElement(CompactFormControlLabel, { value: 'sunday', control: React.createElement(Checkbox, { name: 'sunday', checked: state.sunday, onChange: handleChange }), label: 'S', labelPlacement: 'top' }),
            React.createElement(CompactFormControlLabel, { value: 'monday', control: React.createElement(Checkbox, { name: 'monday', checked: state.monday, onChange: handleChange }), label: 'M', labelPlacement: 'top' }),
            React.createElement(CompactFormControlLabel, { value: 'tuesday', control: React.createElement(Checkbox, { name: 'tuesday', checked: state.tuesday, onChange: handleChange }), label: 'T', labelPlacement: 'top' }),
            React.createElement(CompactFormControlLabel, { value: 'wednesday', control: React.createElement(Checkbox, { name: 'wednesday', checked: state.wednesday, onChange: handleChange }), label: 'W', labelPlacement: 'top' }),
            React.createElement(CompactFormControlLabel, { value: 'thursday', control: React.createElement(Checkbox, { name: 'thursday', checked: state.thursday, onChange: handleChange }), label: 'TH', labelPlacement: 'top' }),
            React.createElement(CompactFormControlLabel, { value: 'friday', control: React.createElement(Checkbox, { name: 'friday', checked: state.friday, onChange: handleChange }), label: 'F', labelPlacement: 'top' }),
            React.createElement(CompactFormControlLabel, { value: 'saturday', control: React.createElement(Checkbox, { name: 'saturday', checked: state.saturday, onChange: handleChange }), label: 'Sat', labelPlacement: 'top' })),
        willError && (React.createElement(CustomHelperText, { error: !!errorValue }, errorValue))));
};
CustomFormikWeekCheckbox.defaultProps = {
// bla: 'test',
};
//# sourceMappingURL=CustomFormikWeekCheckbox.js.map